import { ɵɵdefineInjectable, Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { zxcvbn } from 'zxcvbn3';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgxPasswordStrengthMeterComponent_ng_container_3_small_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.feedback.warning, " ");
} }
function NgxPasswordStrengthMeterComponent_ng_container_3_small_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const suggetion_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(suggetion_r4);
} }
function NgxPasswordStrengthMeterComponent_ng_container_3_small_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 6);
    ɵngcc0.ɵɵtemplate(1, NgxPasswordStrengthMeterComponent_ng_container_3_small_2_ng_container_1_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.feedback.suggestions);
} }
function NgxPasswordStrengthMeterComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NgxPasswordStrengthMeterComponent_ng_container_3_small_1_Template, 2, 1, "small", 3);
    ɵngcc0.ɵɵtemplate(2, NgxPasswordStrengthMeterComponent_ng_container_3_small_2_Template, 2, 1, "small", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.feedback.warning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.feedback.suggestions && ctx_r0.feedback.suggestions.length > 0);
} }
class NgxPasswordStrengthMeterService {
    constructor() { }
    /**
     * This will calculates the password strength
     *
     * @param password - Password
     *
     * @returns An instance of ScoreResult
     */
    calculate(password) {
        if (password === undefined || password === null)
            throw new Error('Password should be a valid string');
        const { score, feedback } = zxcvbn(password);
        return { score, feedback };
    }
}
NgxPasswordStrengthMeterService.ɵfac = function NgxPasswordStrengthMeterService_Factory(t) { return new (t || NgxPasswordStrengthMeterService)(); };
NgxPasswordStrengthMeterService.ɵprov = ɵɵdefineInjectable({ factory: function NgxPasswordStrengthMeterService_Factory() { return new NgxPasswordStrengthMeterService(); }, token: NgxPasswordStrengthMeterService, providedIn: "root" });
NgxPasswordStrengthMeterService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPasswordStrengthMeterService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const ɵ0 = (v) => ({
    suggestions: [],
    warning: `Password should me greater than ${v}`,
}), ɵ1 = (v) => ({
    suggestions: [],
    warning: `Password should me less than ${v}`,
});
const getLengthRuleErrorMessage = {
    min: ɵ0,
    max: ɵ1,
};
class NgxPasswordStrengthMeterComponent {
    constructor(service) {
        this.service = service;
        this.min = 8;
        this.max = 30;
        this.enableLengthRule = true;
        this.enableFeedback = false;
        this.colors = [];
        this.strengthChange = new EventEmitter();
        this.strength = null;
        this.feedback = null;
        this.previousStrength = null;
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        const { password } = changes;
        if (!password || password.previousValue === password.currentValue)
            return;
        this.calculateStrength();
    }
    calculateStrength() {
        if (!this.password) {
            this.strength = null;
            this.feedback = null;
            return;
        }
        if (this.enableLengthRule &&
            (this.password.length < this.min || this.password.length > this.max)) {
            this.strength = 0;
            if (this.password.length < this.min) {
                this.feedback = getLengthRuleErrorMessage['min'](this.min);
            }
            else {
                this.feedback = getLengthRuleErrorMessage['max'](this.max);
            }
        }
        else {
            const { score, feedback } = this.service.calculate(this.password);
            this.strength = score;
            this.feedback = this.enableFeedback ? feedback : null;
        }
        if (this.previousStrength !== this.strength) {
            this.strengthChange.emit(this.strength);
            this.previousStrength = this.strength;
        }
    }
}
NgxPasswordStrengthMeterComponent.ɵfac = function NgxPasswordStrengthMeterComponent_Factory(t) { return new (t || NgxPasswordStrengthMeterComponent)(ɵngcc0.ɵɵdirectiveInject(NgxPasswordStrengthMeterService)); };
NgxPasswordStrengthMeterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxPasswordStrengthMeterComponent, selectors: [["ngx-password-strength-meter"]], inputs: { min: "min", max: "max", enableLengthRule: "enableLengthRule", enableFeedback: "enableFeedback", colors: "colors", password: "password" }, outputs: { strengthChange: "strengthChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 2, consts: [[1, "strength-meter"], [1, "strength-meter-fill"], [4, "ngIf"], ["class", "password-feedback", 4, "ngIf"], ["class", "password-suggetion", 4, "ngIf"], [1, "password-feedback"], [1, "password-suggetion"], [4, "ngFor", "ngForOf"]], template: function NgxPasswordStrengthMeterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 0);
        ɵngcc0.ɵɵelement(2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, NgxPasswordStrengthMeterComponent_ng_container_3_Template, 3, 2, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("data-strength", ctx.strength);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enableFeedback && ctx.feedback);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf], styles: [".strength-meter[_ngcontent-%COMP%]{--strength-meter-background:#ddd;--strength-meter-score-0:#8b0000;--strength-meter-score-1:#ff4500;--strength-meter-score-2:orange;--strength-meter-score-3:#9acd32;--strength-meter-score-4:green;background:var(--strength-meter-background);border-radius:3px;height:3px;margin:10px auto;position:relative}.strength-meter[_ngcontent-%COMP%]:after, .strength-meter[_ngcontent-%COMP%]:before{background:transparent;border-color:#fff;border-style:solid;border-width:0 5px;content:\"\";display:block;height:inherit;position:absolute;width:calc(20% - 4px);z-index:10}.strength-meter[_ngcontent-%COMP%]:before{left:calc(20% - 4px)}.strength-meter[_ngcontent-%COMP%]:after{right:calc(20% - 4px)}.strength-meter-fill[_ngcontent-%COMP%]{background:transparent;border-radius:inherit;height:inherit;position:absolute;transition:width .5s ease-in-out,background .25s;width:0}.strength-meter-fill[data-strength=\"0\"][_ngcontent-%COMP%]{background:var(--strength-meter-score-0);width:20%}.strength-meter-fill[data-strength=\"1\"][_ngcontent-%COMP%]{background:var(--strength-meter-score-1);width:40%}.strength-meter-fill[data-strength=\"2\"][_ngcontent-%COMP%]{background:var(--strength-meter-score-2);width:60%}.strength-meter-fill[data-strength=\"3\"][_ngcontent-%COMP%]{background:var(--strength-meter-score-3);width:80%}.strength-meter-fill[data-strength=\"4\"][_ngcontent-%COMP%]{background:var(--strength-meter-score-4);width:100%}.password-feedback[_ngcontent-%COMP%], .password-suggetion[_ngcontent-%COMP%]{color:#6c757d!important;display:inline-block;font-size:70%;font-weight:400;margin-top:.25rem}"] });
NgxPasswordStrengthMeterComponent.ctorParameters = () => [
    { type: NgxPasswordStrengthMeterService }
];
NgxPasswordStrengthMeterComponent.propDecorators = {
    password: [{ type: Input }],
    min: [{ type: Input }],
    max: [{ type: Input }],
    enableLengthRule: [{ type: Input }],
    enableFeedback: [{ type: Input }],
    colors: [{ type: Input }],
    strengthChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPasswordStrengthMeterComponent, [{
        type: Component,
        args: [{ selector: 'ngx-password-strength-meter', template: "<div>\n  <div class=\"strength-meter\">\n    <div class=\"strength-meter-fill\" [attr.data-strength]=\"strength\"></div>\n  </div>\n  <ng-container *ngIf=\"enableFeedback && feedback\">\n    <small class=\"password-feedback\" *ngIf=\"feedback.warning\">\n      {{ feedback.warning }}\n    </small>\n    <small class=\"password-suggetion\" *ngIf=\"feedback.suggestions && feedback.suggestions.length > 0\">\n      <ng-container *ngFor=\"let suggetion of feedback.suggestions\">{{ suggetion }}</ng-container>\n    </small>\n  </ng-container>\n</div>\n", styles: [".strength-meter{--strength-meter-background:#ddd;--strength-meter-score-0:#8b0000;--strength-meter-score-1:#ff4500;--strength-meter-score-2:orange;--strength-meter-score-3:#9acd32;--strength-meter-score-4:green;background:var(--strength-meter-background);border-radius:3px;height:3px;margin:10px auto;position:relative}.strength-meter:after,.strength-meter:before{background:transparent;border-color:#fff;border-style:solid;border-width:0 5px;content:\"\";display:block;height:inherit;position:absolute;width:calc(20% - 4px);z-index:10}.strength-meter:before{left:calc(20% - 4px)}.strength-meter:after{right:calc(20% - 4px)}.strength-meter-fill{background:transparent;border-radius:inherit;height:inherit;position:absolute;transition:width .5s ease-in-out,background .25s;width:0}.strength-meter-fill[data-strength=\"0\"]{background:var(--strength-meter-score-0);width:20%}.strength-meter-fill[data-strength=\"1\"]{background:var(--strength-meter-score-1);width:40%}.strength-meter-fill[data-strength=\"2\"]{background:var(--strength-meter-score-2);width:60%}.strength-meter-fill[data-strength=\"3\"]{background:var(--strength-meter-score-3);width:80%}.strength-meter-fill[data-strength=\"4\"]{background:var(--strength-meter-score-4);width:100%}.password-feedback,.password-suggetion{color:#6c757d!important;display:inline-block;font-size:70%;font-weight:400;margin-top:.25rem}"] }]
    }], function () { return [{ type: NgxPasswordStrengthMeterService }]; }, { min: [{
            type: Input
        }], max: [{
            type: Input
        }], enableLengthRule: [{
            type: Input
        }], enableFeedback: [{
            type: Input
        }], colors: [{
            type: Input
        }], strengthChange: [{
            type: Output
        }], password: [{
            type: Input
        }] }); })();

class NgxPasswordStrengthMeterModule {
}
NgxPasswordStrengthMeterModule.ɵfac = function NgxPasswordStrengthMeterModule_Factory(t) { return new (t || NgxPasswordStrengthMeterModule)(); };
NgxPasswordStrengthMeterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxPasswordStrengthMeterModule });
NgxPasswordStrengthMeterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxPasswordStrengthMeterModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [NgxPasswordStrengthMeterComponent],
                exports: [NgxPasswordStrengthMeterComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxPasswordStrengthMeterModule, { declarations: function () { return [NgxPasswordStrengthMeterComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxPasswordStrengthMeterComponent]; } }); })();

/*
 * Public API Surface of ngx-password-strength-meter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxPasswordStrengthMeterComponent, NgxPasswordStrengthMeterModule, NgxPasswordStrengthMeterService, ɵ0, ɵ1 };

